<template>
	<FormulateForm v-if="!loading" ref="form" v-model="form" @submit="save">
		<!-- <FormulateInput
		label="Logo"
		name="logo"
		type="file"
		accept="images"
		:displayBlock="true"
		listStyle="thumb"
		validation-name="Logo de la marca"
		validation="required"
	/> -->

		<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

		<FormulateInput label="Razón Social" name="businessName" validation-name="Razón Social" validation="required" />
		<FormulateInput label="Cadena" name="franchise" :options="franchises" type="selectSearch" option-value="id" option-text="name" placeholder="Seleccione un cadena" :disabled="loadingCountries" />
		<FormulateInput label="RUT" name="rut" validation-name="Rut" validation="required" />

		<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />

		<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="optional|^phone" />

		<!-- <div class="section-title mt-4 mb-2">Dirección</div>
		<div class="row row-xs">
			<div class="col-12 col-md-6 mb-2">
				<FormulateInput label="País" validation-name="País" name="addressCountry" :options="countries" type="selectSearch" option-value="id" option-text="name" placeholder="Seleccione un país" validation="required" :disabled="loadingCountries" />
				<div class="formulate-input-help " v-if="loadingCountries">Cargando paises...</div>
			</div>
			<div class="col-12 col-md-6 mb-2">
				<FormulateInput
					label="Region"
					validation-name="Region"
					v-model="selectedRegion"
					:options="regions"
					type="selectSearch"
					option-value="id"
					option-text="name"
					placeholder="Seleccione una region"
					validation="required"
					:disabled="loadingCountries"
				/>
				<div class="formulate-input-help " v-if="loadingCountries">Cargando regiones...</div>
			</div>
											
			<div class="col-12 col-md-6 mb-2">
				<FormulateInput
					label="Localidad"
					validation-name="Localidad"
					name="addressLocality"
					:options="localities"
					type="selectSearch"
					option-value="id"
					option-text="name"
					placeholder="Seleccione una localidad"
					validation="required"
					:disabled="loadingCountries"
				/>
				<div class="formulate-input-help " v-if="loadingCountries">Cargando localidades...</div>
			</div>

			<div class="col-12 col-md-6 mb-2">
				<FormulateInput label="Ciudad" name="addressCity" validation-name="Ciudad" validation="required" />
			</div>
		</div>

		<FormulateInput label="Calle número, etc..." name="addressStreet" validation-name="Ciudad" validation="required" help="Dirección (calle, número, apartamento, etc...)" /> -->

		<div class="section-title mt-4 mb-2">Dirección</div>
		<div class="row row-xs">
			<!-- <div class="col-12 col-md-6 mb-2">
				<FormulateInput
					label="País"
					validation-name="País"
					name="addressCountry"
					:options="countries"
					type="selectSearch"
					option-value="id"
					option-text="name"
					placeholder="Seleccione un país"
					validation="required"
					:disabled="loadingCountries"
				/>
				<div class="formulate-input-help " v-if="loadingCountries">Cargando paises...</div>
			</div> -->
			
			<div class="col-12 col-md-6 mb-2">
				<FormulateInput
					label="Departamento"
					validation-name="Departamento"
					v-model="selectedRegion"
					:options="regions"
					type="selectSearch"
					option-value="id"
					option-text="name"
					placeholder="Seleccione una region"
					validation="required"
					:disabled="loadingCountries"
				/>
				<div class="formulate-input-help " v-if="loadingCountries">Cargando regiones...</div>
			</div>
			
			<div class="col-12 col-md-6 mb-2">
				<FormulateInput
					label="Localidad"
					validation-name="Localidad"
					name="addressLocality"
					:options="localities"
					type="selectSearch"
					option-value="id"
					option-text="name"
					placeholder="Seleccione una localidad"
					validation="required"
					:disabled="loadingCountries"
				/>
				<div class="formulate-input-help " v-if="loadingCountries">Cargando localidades...</div>
			</div>
			
			<!-- <div class="col-12 col-md-6 mb-2">
				<FormulateInput label="Ciudad" name="addressCity" validation-name="Ciudad" validation="required" />
			</div> -->
		</div>

		<div class="row row-xs">
			<div class="col-12 col-md-8 mb-2">
				<FormulateInput label="Calle" name="addressStreet" validation-name="Calle" validation="required" />
			</div>
			<div class="col-12 col-md-4 mb-2">
				<FormulateInput label="Número" name="addressNumber" validation-name="Número" validation="required" />
			</div>
		</div>
		<FormulateInput label="Datos adicionales" name="addressComments"  placeholder="Ej: manzana, solar, número de local, etc..." />


		<div class="section-title mt-4 mb-2">Dirección técnica</div>

		<div class="row row-xs">
			<div class="col-12 col-md-2 mb-2">
				<FormulateInput label="CJPPU" name="managerCJP" validation-name="CJPPU" validation="required" />
			</div>
			<div class="col-12 col-md-5 mb-2">
				<FormulateInput label="Nombre" name="managerName" validation-name="Nombre encargado" validation="required" />
			</div>
			<div class="col-12 col-md-5 mb-2">
				<FormulateInput label="Apellido" name="managerLastname" validation-name="Apellido encargado" validation="required" />
			</div>
		</div>


		<div class="d-flex justify-content-between mt-4">
			<FormulateInput type="button" data-ghost @click="$router.go(-1)">Cancelar</FormulateInput>
			<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
			<FormulateInput type="submit" :label="title" v-else />
		</div>
	</FormulateForm>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import formMixins from "@/mixins/formMixins"

export default {
	name: "LaboratoryForm",
	mixins: [mixins, formMixins],
	props: ["id"],
	data() {
		return {
			title: "Crear farmacia",
			action: "create",
			loading: true,
			saving: false,
			loadingCountries: true,
			countries: [],
			regions: [],
			selectedRegion: null,
			franchises: [],
			form: {
				name: null,
				businessName: null,
				email: null,
				phone: null,
				address: { country: null, city: null, street: null },
				rut: null,
				managerName: null,
				managerLastname: null,
				managerCJP: null,
				franchise: null
			}
		}
	},
	computed:{
		localities(){
			if(this.selectedRegion){
				let regions =  this.regions.find(r=>r.id==this.selectedRegion).localities
				// sort by name
				regions.sort((a,b)=>a.name.localeCompare(b.name))
				return regions
			}
			return []
		}
	},
	async beforeMount() {
		await this.fetchData()
		if (this.id) {
			this.action = "update"
			this.title = `Editar farmacia`
			await this.load()
		}
		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					name: this.form.name,
					businessName: this.form.businessName,
					email: this.form.email,
					phone: this.form.phone,
					// addressCountry: this.form.addressCountry,
					addressCountry: 226,
					addressLocality: this.form.addressLocality,
					addressCity: this.form.addressCity,
					addressStreet: this.form.addressStreet,
					addressNumber: this.form.addressNumber,
					addressComments: this.form.addressComments,
					rut: this.form.rut,
					managerName: this.form.managerName,
					managerLastname: this.form.managerLastname,
					managerCJP: this.form.managerCJP,
					franchise: this.form.franchise
				}

				if (this.action == "create") {
					this.create(dataInput)
				}
				if (this.action == "update") {
					this.update(dataInput)
				}
			}
		},

		create(data) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: PharmacyInput!) {
							pharmacyCreate(data: $data) {
								id
								name
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					this.$toast.success("Farmacia creada correctamente")
					this.$emit("created", data.pharmacyCreate)
					this.saving = false
				})
				.catch(error => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		update(dataInput) {
			console.log("dataInput", dataInput)
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: PharmacyInput!) {
							pharmacyUpdate(id: $id, data: $data) {
								id
								name
							}
						}
					`,
					variables: {
						id: this.id,
						data: dataInput
					}
				})
				.then(({ data }) => {
					this.$toast.success("Farmacia editada correctamente")
					this.$emit("updated", data.pharmacyUpdate)
					this.saving = false
				})
				.catch(error => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							pharmacy(id: $id) {
								id
								name
								businessName
								email
								phone {
									countryCode
									national
									international
									type
									validated
								}
								address {
									country {
										id
										name
									}
									locality{
										id name
									}
									street
									number
									comments
								}
								franchise {
									id
									name
								}
								rut
								managerName
								managerLastname
								managerCJP
							}
						}
					`,
					variables: { id: this.id },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {

					this.form = {
						...this.$omitDeep(data.pharmacy, "__typename"),
						addressCountry: data.pharmacy.address && data.pharmacy.address.country ? data.pharmacy.address.country.id : null,
						addressLocality: data.pharmacy.address && data.pharmacy.address.locality ? data.pharmacy.address.locality.id : null,
						addressStreet: data.pharmacy.address && data.pharmacy.address.street ? data.pharmacy.address.street : null,
						addressNumber: data.pharmacy.address && data.pharmacy.address.number ? data.pharmacy.address.number : null,
						addressComments: data.pharmacy.address && data.pharmacy.address.comments ? data.pharmacy.address.comments : null,
						franchise: data.pharmacy.franchise ? data.pharmacy.franchise.id : null
					}
					this.selectedRegion = this.regions.find(r=>r.localities.find(l=>l.id==data.pharmacy.address.locality.id)).id
				})
				.catch(err => {
					console.log(err)
					this.$toast.success("El item que desea editar no existe")
					this.$router.go(-1)
				})
		},

		fetchData() {
			this.loadingCountries = true
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
							franchises {
								data {
									id
									name
								}
							}
							regions{
								id
								name
								localities{
									id name
								}
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.countries = data.countries
					this.regions = data.regions
					this.franchises = data.franchises.data
					this.loadingCountries = false
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>

<style></style>
